// src/components/create-project/services/projectService.ts
import api from '@/services/axios';

// create project
export const createProject = async (data: any) => {
  try {
    const response = await api.post('/project', data);
    if (response.status === 200) {
      return { success: true, message: 'Project created successfully', data: response.data.data };
    }
    return { success: false, message: 'Failed to create project', error: response.data.message };
  } catch (error) {
    throw error;
  }
};

// get projects with pagination
export const getProjects = async (page = 1, limit = 10) => {
  try {
    const response = await api.get('/project', {
      params: { page, limit },
    });
    if (response.status === 200) {
      return { success: true, message: 'Projects fetched successfully', data: response.data.data };
    }
    return { success: false, message: 'Failed to fetch projects', error: response.data.message };
  } catch (error) {
    throw error;
  }
};

// get project by ID
export const getProjectById = async (id: string) => {
  try {
    const response = await api.get(`/project/${id}`);
    if (response.status === 200) {
      return { success: true, message: 'Project fetched successfully', data: response.data.data };
    }
    return { success: false, message: 'Failed to fetch project', error: response.data.message };
  } catch (error) {
    throw error;
  }
};

// delete project
export const deleteProject = async (id: string) => {
  try {
    const response = await api.delete(`/project/${id}`);
    if (response.status === 200) {
      return { success: true, message: 'Project deleted successfully', data: response.data.data };
    }
    return { success: false, message: 'Failed to delete project', error: response.data.message };
  } catch (error) {
    throw error;
  }
};
